<div class="availability-icon" aria-hidden="true">
  <i [class]="baseClass"></i>
  <span class="availability-icon__fill" [style.width]="fillPercent" [style.color]="fillColor">
    <i [class]="fillClass"></i>
  </span>
</div>
